/* =========================================================================
 * Shiro Matcha Survey #1 — question data (customer-facing: English)
 * -------------------------------------------------------------------------
 * ★ Edit ONLY this file to change questions (UI logic does not depend on it).
 * Source of truth: "shiro matcha アンケート.xlsx" sheet "template2"
 *   col E = question (EN)  /  col F = format  /  col G = branch + options(JP)
 *   col I = options (EN)   /  col B = analytics tag
 *
 * question.type     : 'single' | 'multi'
 * question.maxSelect: max choices for multi (e.g. 3)
 * question.required : true if required
 * question.showIf   : { questionId, in:[values] } — conditional display
 * question.tag      : analytics tag (from xlsx col B), used for sheet headers
 * option.value      : stable slug for branching / aggregation
 * option.label      : shown to customer + stored to spreadsheet
 * option.hasText    : true renders an "Other – please specify" text box
 *
 * Branch: Q2 "Have you purchased" → Yes: show Q3 / No: show Q4 & Q5
 * ========================================================================= */
window.SHIRO_SURVEY = {
  version: "v1-2026-07",
  questions: [
    {
      id: "q1",
      type: "multi",
      maxSelect: 3,
      required: true,
      // JP: Shiro matchaを何で知りましたか？
      label: "How did you hear about Shiro Matcha?",
      note: "Select up to 3",
      options: [
        { value: "instore",   label: "In-store" },
        { value: "google",    label: "Google" },
        { value: "instagram", label: "Instagram" },
        { value: "facebook",  label: "Facebook" },
        { value: "tiktok",    label: "TikTok" },
        { value: "linkedin",  label: "LinkedIn" },
        { value: "event",     label: "Event" },
        { value: "referral",  label: "Referral or word of mouth" },
        { value: "other",     label: "Other – please specify", hasText: true }
      ]
    },
    {
      id: "q2",
      type: "single",
      required: true,
      // JP: 購入したことがあるか
      label: "Have you purchased from us before?",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no",  label: "No" }
      ]
    },
    {
      id: "q3",
      type: "multi",
      maxSelect: 3,
      required: true,
      tag: "Purchase_DecisionInfo_Actual",
      showIf: { questionId: "q2", in: ["yes"] },
      // JP: 【購入したことがある方】購入の決め手になった情報は何ですか？
      label: "Since you've purchased before, what information helped you decide to buy?",
      note: "Select up to 3",
      options: [
        { value: "photo_color",   label: "Colour and texture photos" },
        { value: "photo_package", label: "Packaging photos" },
        { value: "origin_grade",  label: "Origin and grade info" },
        { value: "usage_media",   label: "Photos or videos of matcha in use" },
        { value: "price",         label: "Price and shipping cost" },
        { value: "delivery",      label: "Delivery time" },
        { value: "reviews",       label: "Reviews and feedback" },
        { value: "brand_story",   label: "Brand story" },
        { value: "freshness",     label: "Expiry and freshness info" },
        { value: "knew_gelato",   label: "Already knew Shiro Gelato & Snack" },
        { value: "other",         label: "Other – please specify", hasText: true }
      ]
    },
    {
      id: "q4",
      type: "multi",
      maxSelect: 3,
      required: true,
      tag: "Purchase_DecisionInfo_Needed",
      showIf: { questionId: "q2", in: ["no"] },
      // JP: 【まだ購入したことがない方】購入前に知りたい情報・不安を解消するために必要な情報は？
      label: "If you haven't purchased yet, what information would help ease any concerns before buying?",
      note: "Select up to 3",
      options: [
        { value: "grade_taste",   label: "Matcha grades and flavour" },
        { value: "origin_method", label: "Origin and growing methods" },
        { value: "how_to_use",    label: "How to prepare matcha" },
        { value: "value_quality", label: "Value for price" },
        { value: "shelf_storage", label: "Expiry and storage info" },
        { value: "gift_fit",      label: "Good for gifting" },
        { value: "reviews",       label: "Reviews and feedback" },
        { value: "other",         label: "Other – please specify", hasText: true }
      ]
    },
    {
      id: "q5",
      type: "single",
      required: true,
      showIf: { questionId: "q2", in: ["no"] },
      // JP: 【まだ購入したことない方】どちらのエリアにお住まいですか
      label: "If you haven't purchased yet, which area do you live in?",
      options: [
        { value: "nsw", label: "New South Wales (NSW)" },
        { value: "vic", label: "Victoria (VIC)" },
        { value: "qld", label: "Queensland (QLD)" },
        { value: "wa",  label: "Western Australia (WA)" },
        { value: "sa",  label: "South Australia (SA)" },
        { value: "tas", label: "Tasmania (TAS)" },
        { value: "act", label: "Australian Capital Territory (ACT)" },
        { value: "nt",  label: "Northern Territory (NT)" },
        { value: "other", label: "Other – please specify", hasText: true }
      ]
    },
    {
      id: "q6",
      type: "multi",
      maxSelect: 3,
      required: true,
      tag: "Values_SelectionCriteria",
      // JP: 抹茶を選ぶ際に重視しているポイント・価値観は？
      label: "What matters most to you when choosing matcha?",
      note: "Select up to 3",
      options: [
        { value: "taste",          label: "Taste and flavour" },
        { value: "color",          label: "Vibrant colour" },
        { value: "origin_brand",   label: "Origin or brand" },
        { value: "safety",         label: "Organic or pesticide-free" },
        { value: "price",          label: "Price" },
        { value: "package",        label: "Packaging design" },
        { value: "gift",           label: "Good for gifting" },
        { value: "sustainability", label: "Environmental sustainability" },
        { value: "story",          label: "Producer or origin story" },
        { value: "other",          label: "Other – please specify", hasText: true }
      ]
    },
    {
      id: "q7",
      type: "multi",
      maxSelect: 3,
      required: true,
      tag: "Behavior_Usage",
      // JP: 抹茶の主な使い方
      label: "How do you mainly use matcha?",
      note: "Select up to 3",
      options: [
        { value: "latte",    label: "Matcha latte at home" },
        { value: "ceremony", label: "Traditional tea ceremony" },
        { value: "cooking",  label: "Baking or cooking" },
        { value: "smoothie", label: "Smoothies or other drinks" },
        { value: "gift",     label: "Gifting" },
        { value: "other",    label: "Other – please specify", hasText: true }
      ]
    },
    {
      id: "q8",
      type: "multi",
      maxSelect: 3,
      required: true,
      tag: "Qual_Expectation",
      // JP: Shiro Matchaのサイトやコンテンツに期待すること
      label: "What would you like to see more of on the Shiro Matcha website or content?",
      note: "Select up to 3",
      options: [
        { value: "image_quality", label: "Better product photos" },
        { value: "product_info",  label: "More product details" },
        { value: "search_compare", label: "Easier search and comparison" },
        { value: "gift_ease",     label: "Easier gift shopping" },
        { value: "assortment",    label: "Wider range of products" },
        { value: "more_reviews",  label: "More reviews" },
        { value: "culture",       label: "More on tea culture and origin" },
        { value: "how_to_guide",  label: "Matcha prep and recipe guides" },
        { value: "ranking",       label: "Rankings and best-sellers" },
        { value: "other",         label: "Other – please specify", hasText: true }
      ]
    },
    {
      id: "q9",
      type: "single",
      required: false,
      tag: "Demographics_Age",
      // JP: ご年齢をお選びください
      label: "What is your age?",
      options: [
        { value: "under18", label: "Under 18" },
        { value: "18_24",   label: "18–24" },
        { value: "25_34",   label: "25–34" },
        { value: "35_44",   label: "35–44" },
        { value: "45_54",   label: "45–54" },
        { value: "55_64",   label: "55–64" },
        { value: "65plus",  label: "65+" },
        { value: "na",      label: "Prefer not to say" }
      ]
    },
    {
      id: "q10",
      type: "single",
      required: false,
      tag: "Demographics_Gender",
      // JP: 性別をお選びください
      label: "What is your gender?",
      options: [
        { value: "woman",     label: "Woman" },
        { value: "man",       label: "Man" },
        { value: "nonbinary", label: "Non-binary" },
        { value: "another",   label: "Another gender" },
        { value: "na",        label: "Prefer not to say" }
      ]
    }
  ]
};
